import React from "react";
import PaySlip from "./PaySlip";
import {connect} from "react-redux";
import PaySlipFormBaltika from "./PaySlipFormBaltika";
import PaySlipFormSlavutich from "./PaySlipFormSlavutich";
import PaySlipFormAlivaria from "./PaySlipFormAlivaria";
import {WorkplaceTypes} from "../Common/constants";

const PaySlipRouter = (props) => {
    //PaySlip: {link: "PaySlip", render: (id) => <SMSAuthenticator><PaySlip commandId={id} /></SMSAuthenticator>},
    switch (props.appParams.workplaceType) {
        case WorkplaceTypes.Baltika:
            return <PaySlip {...props}
                            paySlipForm={props => <PaySlipFormBaltika {...props}/>}
                            headerValues={["FioTn", "AsCodeName", "SumPNDbt", "SumPNVal", "BegSaldo", "EndSaldo"]}
            />;
        case WorkplaceTypes.Slavutich:
            return <PaySlip {...props}
                            paySlipForm={props => <PaySlipFormSlavutich {...props}/>}
                            headerValues={["Fio", "AsCode", "AsName", "DbtSum", "CrdSum", "BegSaldo", "EndSaldo"]}
            />;
        case WorkplaceTypes.Alivaria:
            return <PaySlip {...props}
                            paySlipForm={props => <PaySlipFormAlivaria {...props}/>}
                            headerValues={["Fio", "AsCode", "AsName", "DbtSum", "CrdSum", "BegSaldo", "EndSaldo"]}
            />;
        default:
            return <PaySlip {...props}
                            paySlipForm={props => <PaySlipFormBaltika {...props}/>}
                            headerValues={["FioTn", "AsCodeName", "SumPNDbt", "SumPNVal", "BegSaldo", "EndSaldo"]}
            />;

    }
}

function mapStateToProps(state, ownProps) {
    function getDataItem(place, type) {
        switch (state.appState.appParams.workplaceType) {
            case WorkplaceTypes.Baltika: {
                if (place === 'header') {
                    return type === 'paramset' ? state.paySlipState.lckPrintPayListHdrParams : state.paySlipState.lckPrintPayListHdr;
                } else {
                    return type === 'paramset' ? null : state.paySlipState.lckPrintPayListTab;
                }
            }
            case WorkplaceTypes.Slavutich: {
                if (place === 'header') {
                    return type === 'paramset' ? state.paySlipState.CalcKernelRep_vckPayListSlavLkMainParams : state.paySlipState.CalcKernelRep_vckPayListSlavLkMain;
                } else {
                    return type === 'paramset' ? null : state.paySlipState.CalcKernelRep_vckPayListSlavLkTabMain;
                }
            }
            case WorkplaceTypes.Alivaria: {
                if (place === 'header') {
                    return type === 'paramset' ? state.paySlipState.CalcKernelRep_LckPayListAlivariaLkMainParams : state.paySlipState.CalcKernelRep_LckPayListAlivariaLkMain;
                } else {
                    return type === 'paramset' ? null : state.paySlipState.CalcKernelRep_LckPayListAlivariaLkTab;
                }
            }
            default: {
                if (place === 'header') {
                    return type === 'paramset' ? state.paySlipState.lckPrintPayListHdrParams : state.paySlipState.lckPrintPayListHdr;
                } else {
                    return type === 'paramset' ? null : state.paySlipState.lckPrintPayListTab;
                }
            }
        }
    }

    return {
        lckPrintPayListHdr: getDataItem('header', 'data'),
        lckPrintPayListHdrParams: getDataItem('header', 'paramset'),
        lckPrintPayListTab: getDataItem('table', 'data'),
        appParams: state.appState.appParams
    }
}

export default connect(mapStateToProps)(PaySlipRouter);